<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <div class="main">
      <div class="df-foot-line"></div>
      <div class="df-foot-nav">
        <span
          @click="handleUserClickedTabbar(index)"
          :class="index == tabbarIndex ? 'on' : ''"
          v-for="(item, index) of tabbar"
          :key="index"
          ><i><img :src="item.icourl"/></i>
          {{ item.name }}
        </span>
      </div>
      <div class="bottom icp flexStyle1">
        备案编号：<a href="http://beian.miit.gov.cn/" target="_blank">{{
          webIcp
        }}</a>
      </div>
      <div class="liucheng">
        <span v-for="icon of icons" :key="icon.id"
          ><img
            :src="icon.icon"
            @mouseover="changeImageSrc(icon.id, 'hover')"
            @mouseleave="changeImageSrc(icon.id, '')"
        /></span>
      </div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { baseInfoRequest } from "../../public/js/service";
export default {
  data() {
    // 1.data
    return {
      webIcp: "",
      tabbar: [
        // 1.1.tabbar按钮
        { name: "商品中心", id: 1, icourl: require("../../image/nav1.png") },
        { name: "订单中心", id: 2, icourl: require("../../image/nav2.png") },
        { name: "结算中心", id: 3, icourl: require("../../image/nav3.png") },
        { name: "会员中心", id: 4, icourl: require("../../image/nav4.png") },
        { name: "帮助中心", id: 5, icourl: require("../../image/nav5.png") },
      ],
      tabbarIndex: 0,
      icons: [
        {
          icon: require("@/image/d1.png"),
          id: 1,
        },
        {
          icon: require("@/image/d2.png"),
          id: 2,
        },
        {
          icon: require("@/image/d3.png"),
          id: 3,
        },
        {
          icon: require("@/image/d4.png"),
          id: 4,
        },
        {
          icon: require("@/image/d5.png"),
          id: 5,
        },
        {
          icon: require("@/image/d6.png"),
          id: 6,
        },
      ],
    };
  },
  created() {
    this.getBaseInfo();
  },
  methods: {
    // 2.methods
    getBaseInfo() {
      // 2.6.获取站点基础信息
      let url = window.location.hostname;
      if (
        url == "192.168.1.34" ||
        url == "120.55.13.213" ||
        url == "bbbb.df.guoxinzulin.com" ||
        url == "localhost"
      ) {
        url = "bbbb.df.vue.waiwubang.com";
        url = "01.daifa.zhongliangec.com";
      }

      console.log("111111111");
      baseInfoRequest(url).then((res) => {
        console.log(res);
        if (res) {
          let r = res.data[0];
          this.webIcp = r.web_icp || "";
        }
      });
    },
    handleUserClickedTabbar(index) {
      // 2.1.用户点击tabbar按键
      // if (index!=this.tabbarIndex){
      //     this.tabbarPageChange(index);
      // }
      this.tabbarPageChange(index);
    },

    tabbarPageChange(index) {
      // 2.2.tabbar页面切换方法
      switch (index) {
        case 0:
          this.$router.push("/goodsCenter?buttonIndex=0");
          break;
        case 1:
          localStorage.orderButtonIndex = 0;
          this.$router.push("/orderCenter?buttonIndex=0");
          break;
        case 2:
          this.$router.push("/financeCenter?buttonIndex=0");
          break;
        case 3:
          this.$router.push("/ownInfo?buttonIndex=0");
          break;
        case 4:
          this.$router.push("/helpInfo?buttonIndex=0");
          break;
      }
      this.$emit("goOnePage");
    },
    changeImageSrc(key, way) {
      console.log("鼠标移入/移出");
      // 移入或移出时图标名后缀变化('-active'表示移入状态;默认状态后缀为空'')
      let tempStr = way === "hover" ? "-active" : "";
      this.icons[key - 1].icon = require("@/image/d" + key + tempStr + ".png");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./footer.scss";
</style>
